module.exports = __webpack_public_path__ + "895bdcafde1b1c66a52fd8b6a859f103.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/covers/cover_18.jpg
 ** module id = 600
 ** module chunks = 0
 **/